import { render, staticRenderFns } from "./editActivities.vue?vue&type=template&id=545dc71f&scoped=true"
import script from "./editActivities.vue?vue&type=script&lang=js"
export * from "./editActivities.vue?vue&type=script&lang=js"
import style0 from "./editActivities.vue?vue&type=style&index=0&id=545dc71f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545dc71f",
  null
  
)

export default component.exports